import { IconProps } from "./types";

export const IconlyFilter = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.78216 3H16.2169C19.165 3 21 5.08119 21 8.02638V15.9736C21 18.9188 19.165 21 16.2159 21H7.78216C4.83405 21 3 18.9188 3 15.9736V8.02638C3 5.08119 4.84281 3 7.78216 3Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0034 9.14815C12.0082 8.37463 11.3855 7.74415 10.613 7.73831C9.83948 7.73344 9.20802 8.35615 9.20315 9.12869C9.19829 9.9022 9.82099 10.5337 10.5935 10.5385H10.6033C11.3739 10.5414 12.0005 9.91874 12.0034 9.14815Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9981 14.8513C11.9932 15.6248 12.6159 16.2553 13.3885 16.2612C14.162 16.266 14.7934 15.6433 14.7983 14.8708C14.8032 14.0973 14.1805 13.4658 13.4079 13.4609H13.3982C12.6276 13.458 12.001 14.0807 11.9981 14.8513Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.82422 14.8613H11.9983M14.8023 14.8613H16.1742"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1733 9.13867H11.9993M9.19611 9.13867H7.82422"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
